module.exports = {
  MIN_VALUE: "000001",
  MAX_VALUE: "999999",
};
